import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import Asset from './Asset';

import { AssetProps } from './Helpers';

export default class KeyFeatures extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openToggle: props.expanded,
    };
  }

  // eslint-disable-next-line class-methods-use-this
  renderDetailsFeatures() {
    const {
      points,
    } = this.props;
    const wide = points.length < 4 && 'wide';
    return points.map((feature, i) => {
      let image;
      if (feature.images && feature.images.length > 0) {
        image = (
          // We have to use GraphCMSPicture because the images that come back
          // from GraphCMS are SVG images.
          // GraphImg does not work well with SVGs since they lack height/widths.
          <LazyLoad offset={0} placeholder={<div className="key-features-item-placeholder"/>}>
            <picture className="key-features-item-images">
              <source type="image/webp" srcSet={`https://media.graphassets.com/output=f:webp/output=c:true/output=t:true/${feature.images[0].handle}`} />
              <source type="image/jpeg" srcSet={`https://media.graphassets.com/output=c:true/output=t:true/${feature.images[0].handle}`} />
              <img alt={feature.header} src={`https://media.graphassets.com/output=c:true/output=t:true/${feature.images[0].handle}`} />
            </picture>
          </LazyLoad>
        );
      }
      return (
        <div key={i}
          className={`key-features-item ${wide}`}
        >
          {image}
          <p className="key-features-item-title">{feature.header}</p>
          <p className="key-features-item-copy">{feature.subHeader}</p>
        </div>
      );
    });
  }

  render() {
    const {
      subHeader,
      images,
      toggleAccordion,
    } = this.props;
    return (
      <section
        id={this.props.anchor || undefined}
        className="pdp-btf-section key-features"
      >
        <div
          className={classNames('pdp-btf-section-title', { active: this.state.openToggle })}
          onClick={toggleAccordion?.bind(this)}
        >
          <h2>{subHeader}</h2>
          <div className="icon-container">
            <i className={classNames('icon', 'icon-nav-arrow', { active: this.state.openToggle })}/>
          </div>
        </div>
        <div className={classNames('pdp-btf-section-wrapper', { active: this.state.openToggle })}>
          {images && images.length > 0
            && (
              <Asset
                asset={images[0]}
                outerWrapperClassName="images"
              />
            )}
          <div className="key-features-item-wrapper">
            {this.renderDetailsFeatures()}
          </div>
        </div>
      </section>
    );
  }
}

KeyFeatures.propTypes = {
  points: PropTypes.array,
  anchor: PropTypes.string,
  subHeader: PropTypes.string,
  toggleAccordion: PropTypes.func,
  images: PropTypes.arrayOf(AssetProps),
};
